<script setup lang="ts">
import { save, close } from "ionicons/icons";
import { reactive } from "vue";
import {
  IonList,
  IonItem,
  IonLabel,
  IonRow,
  IonCol,
  IonGrid,
  IonRadioGroup,
  IonRadio,
  IonNote,
  IonButton,
  IonLoading,
  IonFooter,
  IonIcon,
} from "@ionic/vue";
import { useAppStore } from "@/stores/app";
import { useWindowWidth } from "@/composition/window";

const emit = defineEmits(["cancel"]);

const { isMobile } = useWindowWidth();

const state = reactive({
  loading: false,
});

const appStore = useAppStore();

const cancel = () => {
  emit("cancel");
};

const checkinModeChange = (val: "slow" | "fast") => {
  appStore.setCheckinMode(val);
};
</script>
<template>
  <div>
    <div>
      <ion-item>
        <ion-label>
          <h1>Scanning options</h1>
        </ion-label>
      </ion-item>
      <ion-list>
        <ion-radio-group
          :value="appStore.settings.checkin_mode"
          @ionChange="(event) => checkinModeChange(event.target.value)"
        >
          <ion-item>
            <ion-label>Fast scanning</ion-label>
            <ion-radio value="fast"></ion-radio>
            <ion-note slot="helper">
              Read one QR code after another at top speed.
            </ion-note>
          </ion-item>
          <ion-item>
            <ion-label>Print guest labels</ion-label>
            <ion-radio value="slow"></ion-radio>
            <ion-note slot="helper">
              See guest details after scanning and print labels.
            </ion-note>
          </ion-item>
        </ion-radio-group>
      </ion-list>
    </div>
    <ion-footer v-if="isMobile">
      <div class="container">
        <section>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-button expand="block" color="light" @click="cancel()">
                  <ion-icon slot="start" :icon="close"></ion-icon>
                  Cancel
                </ion-button>
              </ion-col>
              <ion-col>
                <ion-button expand="block" color="success" @click="cancel()">
                  <ion-icon slot="start" :icon="save"></ion-icon>
                  Save
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </section>
      </div>
    </ion-footer>
    <ion-loading :is-open="state.loading" message="Please wait...">
    </ion-loading>
  </div>
</template>
